export default {
    'dashboard.IntroduceRow.totalSales': 'Total Revenue',
    'dashboard.IntroduceRow.indicatorExplain': 'Indicator Explanation',
    'dashboard.IntroduceRow.daySales': 'Daily Revenue',
    'dashboard.IntroduceRow.weekCompare': 'Weekly Compare',
    'dashboard.IntroduceRow.dayCompare': 'Daily Compare',
    'dashboard.IntroduceRow.visits': 'Visits',
    'dashboard.IntroduceRow.dayVisits': 'Daily Visits',
    'dashboard.IntroduceRow.paymentCount': 'Telegram Verification Rate',
    'dashboard.IntroduceRow.conversionRate': 'Conversion Rate',
    'dashboard.IntroduceRow.operationEffect': 'Operational Efficiency',
    // Months
    'dashboard.months.1': 'January',
    'dashboard.months.2': 'February',
    'dashboard.months.3': 'March',
    'dashboard.months.4': 'April',
    'dashboard.months.5': 'May',
    'dashboard.months.6': 'June',
    'dashboard.months.7': 'July',
    'dashboard.months.8': 'August',
    'dashboard.months.9': 'September',
    'dashboard.months.10': 'October',
    'dashboard.months.11': 'November',
    'dashboard.months.12': 'December',
    // Activity Explorer
    'activity.explorer.title': 'Activity Explorer',
    'activity.explorer.subTitle': 'Lookup the entire user interaction history on the system',
    'activity.explorer.headerTitle': 'System Activity Logs',
    'activity.explorer.col.time': 'Time',
    'activity.explorer.col.wallet': 'Wallet Address',
    'activity.explorer.col.type': 'Type',
    'activity.explorer.col.desc': 'Description',
    'activity.explorer.col.status': 'Status',
    'activity.explorer.col.amount': 'Amount',
    'activity.explorer.col.txHash': 'Tx Hash',
    'activity.explorer.pagination.total': 'Total {total} activities',
};
